import { render, staticRenderFns } from "./CreatePlan.vue?vue&type=template&id=3f524479"
import script from "./CreatePlan.vue?vue&type=script&lang=js"
export * from "./CreatePlan.vue?vue&type=script&lang=js"
import style0 from "./CreatePlan.vue?vue&type=style&index=0&id=3f524479&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports